/**
 * IMPORTANT: use this file only to import element from outside of package.
 */

import calendarEs from 'date-fns/locale/es';
import es from '../i18n/es.json';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import meta from '../../package.json';

export * from './configureIcons';
export * from './configureI18n';

export const BS_BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

export const CALENDAR_LOCALES = {
  es: calendarEs
};

export const I18N = {
  namespace: meta.name,
  bundles: {
    es
  }
};
